export default "images/all_inclusive_16dp_47280B_FILL0_wght400_GRAD0_opsz20.svg";